const MOBILE_QUERY = window.matchMedia( "(max-width: 767px)" )
const DOT_CENTER = 22 // stred bodky od horného okraja etapy (mobilná os)

// na mobile je os zvislá – značku umiestni medzi poslednú hotovú a nasledujúcu bodku
function positionMarker( timeline ) {
    const marker = timeline.querySelector( ".schedule-timeline--marker" )

    if ( !marker ) return

    if ( !MOBILE_QUERY.matches ) {
        timeline.style.removeProperty( "--marker-top" )
        return
    }

    const done = timeline.querySelectorAll( ".stage.stage-done" )
    const last = done[ done.length - 1 ]
    const next = last && last.nextElementSibling

    if ( !last || !next || !next.classList.contains( "stage" ) ) {
        timeline.style.removeProperty( "--marker-top" )
        return
    }

    // stred medzi bodkou poslednej hotovej etapy a bodkou nasledujúcej
    const top = ( last.offsetTop + next.offsetTop ) / 2 + DOT_CENTER
    timeline.style.setProperty( "--marker-top", top.toFixed( 1 ) + "px" )
}

function animateScheduleTimeline() {
    const timeline = document.querySelector( ".schedule-timeline" )

    if ( !timeline ) return

    positionMarker( timeline )
    window.addEventListener( "resize", function() { positionMarker( timeline ) })

    if ( document.fonts && document.fonts.ready ) {
        document.fonts.ready.then( function() { positionMarker( timeline ) })
    }

    // skrytý východiskový stav sa aplikuje až keď JS beží
    timeline.classList.add( "is-animated" )

    if ( !( "IntersectionObserver" in window ) ) {
        timeline.classList.add( "in-view" )
        return
    }

    const observer = new IntersectionObserver( function( entries ) {
        entries.forEach( function( entry ) {
            if ( entry.isIntersecting ) {
                timeline.classList.add( "in-view" )
                observer.disconnect()
            }
        })
    }, { threshold: 0.15, rootMargin: "0px 0px -10% 0px" })

    observer.observe( timeline )
}

$(document).ready( function() {
    animateScheduleTimeline()
})
